import { appConfigs } from "../config";
const { serverUrl, fileServer } = appConfigs;

const jsonPostHeader = () => ({
    "Content-Type": "application/json",
    "Accept": "application/json"
})

const authPostHeader = (token) => ({
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Authorization": `Bearer ${token}`
})

/** user registration */
export const registerAccount = (data) => {
    return fetch (`${serverUrl}/account/create`,{
        method: "POST",
        headers: jsonPostHeader(),
        body: JSON.stringify(data)
    })
}

/** upload avatar */
export const uploadPic = (picFile) => {
    const formData = new FormData();
    formData.append("document", picFile);
    return fetch (`${fileServer}/document/upload`,{
        method: "POST",
        Accept: "application/json",
        body: formData,
        mode: "cors"
    })
}

/** user authentication */
export const authentication = (creds) => {
    return fetch (`${serverUrl}/account/authenticate`,{
        method: "POST",
        headers: jsonPostHeader(),
        body: JSON.stringify(creds)
    })
}

/** update account */
export const updateAccount = (data, token) => {
    return fetch (`${serverUrl}/account/update`,{
        method: "PATCH",
        headers: authPostHeader(token),
        body: JSON.stringify(data)
    })
}

/** authorize account */
export const getMyData = (token) => {
    return fetch (`${serverUrl}/account/myaccount`,{
        method: "GET",
        headers: authPostHeader(token),
        mode: 'cors'
    })
}

/** sign out from account */
export const signoutAccount = (token) => {
    return fetch (`${serverUrl}/account/signout`,{
        method: "POST",
        headers: authPostHeader(token),
        mode: "cors"
    })
}

/** mark course as validated */
export const validateLesson = (data, token) => {
    return fetch (`${serverUrl}/account/lesson`,{
        headers: authPostHeader(token),
        method: "POST",
        body: JSON.stringify(data),
        mode: "cors"
    })
}


/** ask ai a question */
export const aiConversation = (data, token) => {
    return fetch (`${serverUrl}/account/askai`,{
        headers: authPostHeader(token),
        body: JSON.stringify(data),
        mode: "cors",
        method: "POST"
    })
}

/** get all accounts avatar username  */
export const getAllUsers = () => {
    return fetch (`${serverUrl}/account/all`,{
        method: "GET"
    })
}